// Stil-Ebene 2: Einblenden beim Scrollen und kompakte Kopfzeile. Ohne Skript bleibt alles sichtbar.
(() => {
  const doc = document.documentElement;
  const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const head = document.querySelector('.head');
  if (head) {
    const onScroll = () => { head.dataset.scrolled = window.scrollY > 24 ? 'true' : 'false'; };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  if (calm || !('IntersectionObserver' in window)) return;
  doc.classList.add('js');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  document.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
})();

// Kopfzeile (16.10.2026): Auswahl „Sprache und Währung“ und Handy-Menü. Nur eine Auswahl gleichzeitig offen,
// schließen per Klick daneben oder Escape. Ohne Skript öffnen und schließen die <details> per Klick, die
// Formulare darin schicken normal ab.
(() => {
  const dds = Array.from(document.querySelectorAll('details[data-head-dd]'));
  if (!dds.length) return;
  dds.forEach((dd) => dd.addEventListener('toggle', () => {
    if (dd.open) dds.forEach((other) => { if (other !== dd) other.open = false; });
  }));
  document.addEventListener('click', (event) => {
    dds.forEach((dd) => { if (dd.open && !dd.contains(event.target)) dd.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    dds.forEach((dd) => {
      if (!dd.open) return;
      dd.open = false;
      const summary = dd.querySelector('summary');
      if (summary) summary.focus();
    });
  });
})();

// EpiKits: kleine Verbesserungen für Produktseite, Startseite und Warenkorb.
// Alles funktioniert auch ohne dieses Skript: Formulare schicken dann normal ab.
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const json = { Accept: 'application/json' };

  // Zähler in der Kopfzeile: der erste Textknoten ist die Zahl, danach folgt ein Screenreader-Text.
  const setCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.dataset.filled = count > 0 ? 'true' : 'false';
      if (el.firstChild && el.firstChild.nodeType === Node.TEXT_NODE) el.firstChild.textContent = String(count);
    });
  };
  const refreshCount = async () => {
    const cart = await (await fetch(root + 'cart.js', { headers: json })).json();
    setCount(cart.item_count);
  };

  document.querySelectorAll('form[data-epk-buy]').forEach((form) => {
    const prices = document.querySelectorAll('[data-epk-price]');
    const statuses = document.querySelectorAll('[data-buy-status]');
    const buttons = document.querySelectorAll('[data-buy-button]');
    const say = (text, link) => {
      statuses.forEach((el) => {
        el.textContent = text;
        if (link) {
          const a = document.createElement('a');
          a.href = root + 'cart';
          a.textContent = link;
          el.append(' ', a);
        }
      });
    };

    form.addEventListener('change', (event) => {
      const input = event.target.closest('input[data-price]');
      if (input) prices.forEach((el) => { el.textContent = input.dataset.price; });
    });

    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      buttons.forEach((b) => { b.disabled = true; });
      say(form.dataset.msgAdding);
      try {
        const added = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: json });
        if (!added.ok) throw new Error(String(added.status));
        await refreshCount();
        say(form.dataset.msgAdded, form.dataset.msgCart);
      } catch (error) {
        say(form.dataset.msgError);
      } finally {
        buttons.forEach((b) => { b.disabled = false; });
      }
    });
  });

  // Kaufleiste auf dem Handy (Produktseite): sichtbar, solange der eigentliche Kaufknopf nicht im Bild ist,
  // also auch beim Öffnen, wenn er noch unterhalb liegt. Die unteren 90 px zählen nicht als „im Bild“, dort
  // liegt die Leiste selbst. Ohne Skript bleibt sie sichtbar.
  const bar = document.querySelector('[data-sticky-buy]');
  const anchor = document.querySelector('[data-buy-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      bar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
    }, { rootMargin: '0px 0px -90px 0px' }).observe(anchor);
  }
})();

// Warenkorb: Mengenänderung sofort übernehmen (ohne Skript über "Mengen aktualisieren").
(() => {
  const form = document.querySelector('form[data-epk-cart]');
  if (!form) return;
  let timer;
  form.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="updates[]"]')) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      const update = form.querySelector('button[name="update"]');
      if (form.requestSubmit && update) form.requestSubmit(update); else form.submit();
    }, 500);
  });
})();
